<slick-dialog key="DIALOG_CHECKLIST" header="Checklist Questions" width="650" #checklistDialog>
    <checklist-edit [(checklistQuestions)]="checklistQuestions" (checklistQuestionsChange)="forwardModelChange($event)" [appointmentId]="appointmentId"></checklist-edit>
</slick-dialog>